import { handleAvailable, handleRequest, handleUnavailable } from '../reducerHandlers';
import { createReducer } from './utils';
import { clearAbort, createAbort, ABORT_KEYS } from './utils/abortManager';
import {
  RESOURCES_TASK_DETAILS_FEATURES_FAILURE,
  RESOURCES_TASK_DETAILS_FEATURES_LOADING,
  RESOURCES_TASK_DETAILS_FEATURES_SUCCESS,
} from './constants';

// Defaults to empty on every non-success path: a feature switch never turns
// itself on for an unconfigured chain.
const NO_FEATURES = [];

const defaultState = {
  loading: false,
  features: NO_FEATURES,
  errorMessage: null,
};

export const reducer = createReducer(defaultState, {
  [RESOURCES_TASK_DETAILS_FEATURES_LOADING]: handleRequest,
  [RESOURCES_TASK_DETAILS_FEATURES_SUCCESS]: handleAvailable,
  [RESOURCES_TASK_DETAILS_FEATURES_FAILURE]: handleUnavailable,
});

export function getResourcesTaskDetailsFeatures() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    const keyState = 'features';
    const loadingName = 'loading';
    dispatch({ type: RESOURCES_TASK_DETAILS_FEATURES_LOADING, payload: { loadingName } });

    const {
      stores: { currentStore },
      tasks: { currentTaskType },
    } = getState();

    try {
      const signal = createAbort(ABORT_KEYS.RESOURCES_TASK_DETAILS_FEATURES);
      const response = await dataSource.requestResourcesTaskDetailsFeatures({
        store: currentStore,
        task_type: currentTaskType,
        signal,
      });
      clearAbort(ABORT_KEYS.RESOURCES_TASK_DETAILS_FEATURES);

      const features = response?.task_details_features;

      dispatch({
        type: RESOURCES_TASK_DETAILS_FEATURES_SUCCESS,
        payload: {
          keyState,
          loadingName,
          data: Array.isArray(features) ? features : NO_FEATURES,
        },
      });
    } catch (error) {
      if (error.name === 'AbortError') return;
      dispatch({
        type: RESOURCES_TASK_DETAILS_FEATURES_FAILURE,
        payload: {
          keyState,
          loadingName,
          defaultState: NO_FEATURES,
          additionalStates: { errorMessage: error },
        },
      });
    }
  };
}
